import { ChevronDown, MenuIcon, PhoneCall } from "lucide-react";
import { menuItems } from "./consts";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useState, useEffect } from "react";
import { MobileMenu } from "./MobileMenu";
import { Marquee } from "../Marquee";
import { SectionCard } from "../SectionCard";

const Header = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const renderNavMenu = () => (
    <ul className="flex items-start justify-between text-[13px] font-[400] text-black-300 lg:w-[750px]">
      {menuItems?.map((item, index) => {
        const isActive = location.pathname === item.to || location.pathname.startsWith(`${item.to}/`);
        const isAboutActive = location.pathname === item.to || location.pathname.startsWith(`${item.to}/`);

        if (item.children) {
          return (
            <div
  key={index}
  className="relative"
  onMouseEnter={() => setOpen(true)}
  onMouseLeave={() => setOpen(false)}
>
  <button
    onClick={() => setOpen(!open)}
    className={cn(
      "flex items-start gap-1 hover:text-primary transition pb-1 group cursor-pointer",
      isAboutActive ? "font-bold text-primary" : ""
    )}
  >
    About Us
    <ChevronDown
      className={`w-4 h-5 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
    />
    <span
      className={cn(
        "absolute left-0 -bottom-1 h-[3px] w-0 bg-primary transition-all duration-300 group-hover:w-full",
        isAboutActive && "w-full"
      )}
    />
  </button>

  {open && (
    <div className="absolute left-0 mt-3 w-56 bg-g-60 rounded-lg shadow-lg overflow-hidden z-50">
      {item?.children?.map((child, childIndex) => {
        const isChildActive =
          location.pathname === child.to ||
          location.pathname.startsWith(`${child.to}/`);

        return (
          <Link
            key={childIndex}
            to={child?.to || ""}
            className={cn(
              "block px-4 py-3 text-gray-800 font-medium transition border-b border-g-600 hover:text-primary",
              isChildActive && "text-primary font-bold bg-gray-100"
            )}
            onClick={() => setOpen(false)}
          >
            {child.title}
          </Link>
        );
      })}
    </div>
  )}
</div>

          );
        } else {
          return (
            <li
              key={index}
              className={cn("relative pb-2 transition-all duration-300")}
            >
              <Link
                to={item.to}
                className={cn(
                  isActive ? "text-primary font-[700]" : "",
                  "relative group hover:text-primary"
                )}
              >
                {item.title}
                <span
                  className={cn(
                    "absolute left-0 -bottom-3 h-[3px] w-0 bg-primary transition-all duration-300 group-hover:w-full",
                    isActive && "w-full"
                  )}
                />
              </Link>
            </li>
          );
        }
      })}
      <li className="flex items-center justify-between">
        <div className="h-7 w-7 rounded-full bg-primary mt-[-20px] flex items-center justify-center">
          <PhoneCall className="h-4 w-4 stroke-white" />
        </div>
        <a
          href="tel:+918801230123"
          className="ml-2 font-[700]"
        >
          +91 8801230123
        </a>
      </li>
    </ul>
  );

  return (
    <>
      {/* Normal Header */}
      <header
        className={cn(
          "top-0 left-0 w-full z-50 transition-all duration-300",
          isSticky ? "fixed bg-white shadow-lg" : "relative bg-transparent"
        )}
      >
        {/* 🔹 Full-width Marquee at Top */}
        {!isSticky && (
          <>
            <Marquee>
  <span className="text-[12px]">
    {/* <b>New Launch:</b>{" "} */}
    <Link
      to="/our-products?product=CAMZALL™"
      className="flex items-center gap-1 inline hover:underline"
    >
      <span className="px-1 text-white text-[10px] bg-red-600 rounded animate-pulse-faster">
        NEW
      </span>
      {" "}
      <img
        src="/img/product_img/SHRIMP/ProductLogos/CAMZALL.png"
        alt="CAMZALL"
        className="h-6 inline-block"
      />
    </Link>

    &{" "}

    <Link
      to="/our-products?product=CAMZALL™-DRY"
      className="flex items-center gap-1 inline hover:underline"
    >
      <span className="px-1 text-white text-[10px] bg-red-600 rounded animate-pulse-faster">
        NEW
      </span>
      {" "}
      <img
        src="/img/product_img/SHRIMP/ProductLogos/CAMZALL-DRY.png"
        alt="CAMZALL DRY"
        className="h-8 inline-block"
      />
    </Link>
    {" "}
    – Advanced Mineral Nutrition for Superior Shrimp Performance!
  </span>
</Marquee>

            {/* 🔹 Divider Line Below Marquee */}
            <div className="h-[1px] w-full bg-linear-to-r from-[#AFAFAF00] to-[#0D507D] my-2" />
          </>
        )}

        {/* Main Header Content */}
        <SectionCard className={cn(isSticky ? "py-2 lg:py-2" : "py-0 lg:py-0 mb-4")}>
          {/* Desktop */}
          <div className="hidden mx-4 lg:grid lg:grid-cols-3 items-center mt-3">
            {/* 🔹 Logo pushed down by margin */}
            <Link to="/" className="py-2">
              <img
                src="/img/logo.png"
                className={cn(isSticky ? "w-[120px]" : "w-[200px]")}
              />
            </Link>
            <nav className="col-span-2">{renderNavMenu()}</nav>
          </div>

          {/* Mobile */}
          <div className="grid grid-cols-1 mx-2 gap-1 lg:hidden">
            <div className="flex items-center justify-between mt-3">
              <img
                src="/img/logo.png"
                className={cn(isSticky ? "w-[120px]" : "w-[150px]")}
              />
              <MenuIcon onClick={() => setMenuOpen(true)} className="text-xl" />
              <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
            </div>
          </div>
        </SectionCard>
      </header>
    </>
  );
};

export default Header;
